export default __webpack_public_path__ + "static/media/phobos_back.e4089147.bmp";